<!--
    Name:			SearchOrder.vue

    Description:	Ask for search input in a Modal (admin only)

    Remarks:
-->

<template>
    <div class="accent0">
        <div class="orderinfo accent-background panel">
            <div class="header row">
                <div class="col-6 text-left">
                    <translate item="Search.SearchForOrder" />
                </div>
            </div>

        </div>

        <div class="content-in search">

            <div class="panel">
                <label class="form-label"><translate item="Search.SearchForOrder" /></label>
                <p class="small">De tijdlijn toont de gevonden orders, maar worden niet ingeplanned</p>
                <div class="input-group mb-3">
                    <input type="text"  class="form-control" v-model="SearchText" />
                    <button type="button" class="btn btn-success" aria-label="" v-on:click="loadDateTime">
                        <translate item="Search.Search" />
                    </button>
                </div>
            </div>

            <div class="panel">
                <label class="form-label">Laad een specifieke dag</label>
                <p class="small">De tijdlijn toont alle orders van de opgegeven dag, <b>tot</b> de opgegeven tijd. De orders worden niet ingeplanned</p>
                <div class="input-group mb-3">
                    <input type="datetime-local" class="form-control" v-model="SearchDateTime" />
                    <button type="button" class="btn btn-success" aria-label="" v-on:click="loadDateTime">
                        <translate item="Search.Search" />
                    </button>
                </div>
            </div>

            <div class="panel" v-if="searching">Bezig met zoeken, moment aub ....</div>
        </div>


        <div class="alert-buttons panel">
            <button type="button" class="btn btn-dark" v-on:click="close" aria-label=""><translate item="General.Close" /></button>
        </div>

    </div>
</template>

<script>

    import Swal from "sweetalert2";
    import translate from '../components/translate'
  
    const searchOrder = {

        components: { translate },

        data: function () {
            return {
                searching: false
            }
        },

        props: {
            SearchText: { type: String },
            SearchDateTime: { type: String }
        },

        created: function () {
            var _this = this;
        },

        methods: {
            searchfororder: function () {

                if (!this.searchText.length) {
                    return;
                }

                this.$signalR.searchOrders(this.searchText).then(() => {
                    this.searching = false;
                }, (err) => { console.log(err); });
            },
            loadDateTime: function () {
                this.searching = true;

                this.$signalR.searchDayTill(this.SearchDateTime).then(() => {
                    this.searching = false;
                }, (err) => { console.log(err); });
            },
            close: function () {
                Swal.close();
            }
        },

        computed: {

        }
    };

    export { searchOrder as default };

</script>
